<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="getReport()"
>
  <div class="report-on-road-operation">
    <form [formGroup]="deliveryManifestForm" class="form-wrapper">
      <app-from-to-date
            [fromControl]="'fromDate'"
            [toControl]="'toDate'"
            [formGroupValue]="deliveryManifestForm"
          ></app-from-to-date>
    <ion-row >
        <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
          <app-form-select
            [label]="CONSTS.ROUTE"
            [options]="routes"
            [customClass]="'scan-type-dropdown report-select'"
            formControlName="route"
          >
          </app-form-select>
        </ion-col>
        <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12" >
          <app-report-format
            [radioButtonValue]="deliveryManifestForm.get('reportFormat')?.value"
            (emitRadioChange)="radioChange($event)"
          ></app-report-format>
        </ion-col>
      
    </ion-row>
    </form>
    <app-download-note [numRows]="'2,000'"> </app-download-note>
  </div>
</app-modal-frame>
<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [hasSingleSubHeaderView]="false"
  [isNonTableView]="true"
>
  @if (deliveryManifestReport && deliveryManifestReport.response) {
    <!-- HEADER LABELS -->
    <ng-container sub-header>
      <table aria-hidden="true" class="pdf-header-table">
        <tr class="pdf-header-row">
          <td>
            {{ PDF_REPORT.FOOTER.LOCATION }}
            {{ reportLocation }}
          </td>
          <td>
            {{ PDF_REPORT.FOOTER.ROUTE }}
            {{ deliveryManifestReport.response.route }}
          </td>
          <td>
            {{ PDF_REPORT.FOOTER.USER }}
            {{ driverUserID }}
          </td>
          <td>
            {{ deliveryManifestReport.response.fromDate }} to
            {{ deliveryManifestReport.response.toDate }}
          </td>
        </tr>
      </table>
    </ng-container>
    <!------------------------>
  }
  @if (deliveryManifestReport && deliveryManifestReport.response) {
    <ng-container custom-report>
      <!-- Custom table header -->
      <table
        aria-hidden="true"
        class="pdf-custom-header-table"
      >
        @for (row of PDF_REPORT.COLUMNS; track row) {
          <tr class="pdf-custom-header-row">
            @for (column of row; track column) {
              <td class="pdf-custom-header-cell">
                <div class="pdf-custom-header-cell-content">
                  {{ column }}
                </div>
              </td>
            }
          </tr>
        }
      </table>
      <!------------------------>
      <!-- Custom table body -->

      @for (stopItem of deliveryManifestGroup; track stopItem; let k = $index) {
        <div [ngClass]="{ 'pdf-page-break-before': k > 0 }">
          <!-- DATA SECTION-->
          <table
            aria-hidden="true"
            class="pdf-body-table"
          >
            @for (
              columnData of stopItem.deliveryManifest;
              track columnData;
              let cLast = $last
            ) {
              @for (
                row of PDF_REPORT.DATA_ROWS;
                track row;
                let j = $index;
                let rLast = $last
              ) {
                <tr class="pdf-body-row">
                  @for (field of row; track field; let i = $index) {
                    <td
                      class="pdf-body-cell"
                      [ngClass]="{
                        'pdf-body-cell-last-row':
                          cLast && rLast && !stopItem.needsCompletion,
                      }"
                    >
                      @switch (true) {
                        @case (field === "routeId") {
                          @if (isAllOptionSelected) {
                            {{ columnData.routeId }}
                          } @else {
                            {{ columnData.stop }}
                          }
                        }
                        @case (
                          field && !(field.includes("/") || field.includes("-"))
                        ) {
                          {{ columnData[field] }}
                        }
                        @case (field && field.includes("/")) {
                          {{ columnData[getFieldIndex(field, 0)] }} /
                          {{ columnData[getFieldIndex(field, 1)] }}
                        }
                        @case (field && field.includes("-")) {
                          @if (
                            !!columnData[getFieldIndex(field, 0, "-")] &&
                            !!columnData[getFieldIndex(field, 1, "-")]
                          ) {
                            {{ columnData[getFieldIndex(field, 0, "-")] }}-{{
                              columnData[getFieldIndex(field, 1, "-")]
                            }}
                          }
                        }
                      }
                    </td>
                  }
                </tr>
              }
            }

            <!-- Signature UI -->
            @if (stopItem.needsCompletion) {
              <tr>
                <td
                  colspan="2"
                  class="pdf-signature-cell"
                >
                  <div class="pdf-signature-line">
                    <span class="pdf-signature-label">{{
                      PDF_REPORT.NEEDED_INFO.NAME
                    }}</span>
                    <span class="pdf-signature-fill"></span>
                  </div>
                </td>
                <td
                  colspan="2"
                  class="pdf-signature-cell"
                >
                  <div class="pdf-signature-line">
                    <span class="pdf-signature-label">{{
                      PDF_REPORT.NEEDED_INFO.SIGNATURE
                    }}</span>
                    <span class="pdf-signature-fill"></span>
                  </div>
                </td>
                <td
                  colspan="3"
                  class="pdf-signature-cell"
                >
                  <div class="pdf-signature-line">
                    <span class="pdf-signature-label">{{
                      PDF_REPORT.NEEDED_INFO.TIME
                    }}</span>
                    <span class="pdf-signature-fill"></span>
                  </div>
                </td>
              </tr>
            }
          </table>
          <!----------------->
        </div>
      }
      <!------------------------>

      <!-- SUMMARY SECTION -->

      <!-- SUMMARY DATA LABELS -->
      <table
        aria-hidden="true"
        class="pdf-summary-meta-table"
      >
        <tr class="pdf-summary-meta-row">
          <td class="pdf-summary-meta-cell">
            {{ PDF_REPORT.FOOTER.SUMMARY }}
          </td>
          <td class="pdf-summary-meta-cell">
            {{ PDF_REPORT.FOOTER.LOCATION }}
            {{ deliveryManifestReport.response.deliveryManifest[0].location }}
          </td>
          <td class="pdf-summary-meta-cell">
            {{ PDF_REPORT.FOOTER.ROUTE }}
            {{ deliveryManifestReport.response.deliveryManifest[0].routeId }}
          </td>
          <td class="pdf-summary-meta-cell">
            {{ PDF_REPORT.FOOTER.USER }}
            {{ driverUserID }}
          </td>
        </tr>
      </table>
      <!------------------------>

      <table aria-hidden="true" class="pdf-summary-table">
        <!-- SUMMARY HEADER ROW -->

        <tr class="pdf-summary-row">
          @for (heading of PDF_REPORT.SUMMARY.HEADING; track heading) {
            <td class="pdf-summary-cell">
              {{ heading }}
            </td>
          }
        </tr>
        <!------------------------>
        <!-- SUMMARY DATA ROW -->
        <tr class="pdf-summary-row">
          @for (field of PDF_REPORT.SUMMARY.DATA_FIELDS; track field) {
            <td class="pdf-summary-cell">
              {{ deliveryManifestReport.response[field] }}
            </td>
          }
        </tr>
        <!------------------------>
      </table>
    </ng-container>
  }
</app-pdf-report-generator>
